import React, { Suspense, useState, useEffect } from "react";
import {
  Route,
  Switch,
  BrowserRouter as Router,
  withRouter,
} from "react-router-dom";

import config from "./config";
import Layout from "./components/Layout/";
import Loader from "./components/Shared/Loader";
import ScrollFixToTop from "./components/Shared/ScrollFixToTop";

import "./Apps.scss";
import "./assets/css/colors/default.css";
import "./assets/css/botanical.css";


import { withLocalize } from "react-localize-redux";
import { renderToStaticMarkup } from "react-dom/server";
import globalTranslations from "./locales/global.json";


import "bootstrap/dist/css/bootstrap.min.css";

import icLogo from './assets/images/ic_logo_text_small.png'
import { NotifyContainer, notifyError } from "./components/Shared/Notify";
import image_placeholder from "./assets/images/image_placeholder.png";

const TenantGroupIndex = React.lazy(() => import("./pages/TenantGroupIndex"));
const TenantIndex = React.lazy(() => import("./pages/TenantIndex"));
const RoomDetail = React.lazy(() => import("./pages/RoomDetail"));
const Payment = React.lazy(() => import("./pages/Payment"));
const BookingConfirm = React.lazy(() => import("./pages/BookingConfirm"));
const ThemePreview = React.lazy(() => import("./pages/ThemePreview"));

function App(props) {
  useEffect(async () => {
    props.initialize({
      languages: [
        { name: "English", code: "en" },
        { name: "Bahasa", code: "id" },
      ],
      translation: globalTranslations,
      options: {
        renderToStaticMarkup,
        renderInnerHtml: false,
        defaultLanguage: "en",
        ignoreTranslateChildren: false,
      },
    });
    setIsLoading(true);
    await getIbeFromWeburl();

  }, [])

  async function getIbeFromWeburl() {
    // let namespace = "horizon-demo-group";
    let namespace = window.location.host.split(".")[0];

    // `namespace` comes off the hostname and used to be interpolated straight
    // into a Hasura query string. It is a path/query parameter now.
    const response = await fetch(
      `${config.backendUrl}/pms/ibe/site?namespace=${encodeURIComponent(namespace)}`
    );
    const ibeData = await response.json();
    if (ibeData != null) {
      if (ibeData.is_tenant_group) {
        //tenant group
        getTenantIbeSites(ibeData.name, ibeData.tenant_group_id);
      } else {
        //tenant
        let tenantResult = {
          bannerTitle1: ibeData.banner_title_1,
          bannerContent1: ibeData.banner_content_1,
          bannerImg1: ibeData.banner_img_url_1,
          bannerTitle2: ibeData.banner_title_2,
          bannerContent2: ibeData.banner_content_2,
          bannerImg2: ibeData.banner_img_url_2,
          bannerTitle3: ibeData.banner_title_3,
          bannerContent3: ibeData.banner_content_3,
          bannerImg3: ibeData.banner_img_url_3,
          fbLink: ibeData.fb_link,
          instaLink: ibeData.insta_link,
          logo: ibeData.logo_url,
          name: ibeData.name,
          id: ibeData.tenant_id
        }
        setIsTenantGroup(false);
        setTenantData(tenantResult);
        setIsLoading(false);
      }
    }
  }


  async function getTenantsByTenantGroupId(tenantGroupId, ibeData, groupName) {
    const response = await fetch(
      `${config.backendUrl}/pms/ibe/tenant-group/${encodeURIComponent(tenantGroupId)}/tenants`
    );
    const tenants = await response.json();
    
    let _ibeData = []
    tenants.map((x => {
      let result = ibeData.filter(i => i.tenant_id === x.id)
      if (result.length !== 0)
        _ibeData.push(result)
    }))

    let groupResult = {
      name: groupName,
      tenants: []
    }

    if (_ibeData.length > 0) {
      _ibeData.forEach(ibe => {
        ibe.forEach(element => {
          groupResult.tenants.push({
            name: element.name,
            logo_url: element.logo_url,
            address1: element.tenant.address_1,
            address2: element.tenant.address_2,
            region: element.tenant.region,
            phoneNo: element.tenant.phone_no,
            zipCode: element.tenant.zip_code,
            country: element.tenant.e_country.comment,
            city: element.tenant.city,
          })
        })
      });
    }

    setIsTenantGroup(true);
    setTenantGroupData(groupResult);
    setIsLoading(false);
  }

  async function getTenantIbeSites(groupName, groupId) {
    // Was a raw Hasura query with the group name interpolated into the
    // query text. The backend owns the read now.
    const response = await fetch(
      `${config.backendUrl}/pms/ibe/site/group?name=${encodeURIComponent(groupName)}`
    );
    const ibeData = await response.json();

    getTenantsByTenantGroupId(groupId, ibeData, groupName)
  }

  const [isLoading, setIsLoading] = useState(false);
  const [isTenantGroup, setIsTenantGroup] = useState(false);
  const [tenantGroupData, setTenantGroupData] = useState({
    name: "",
    tenants: []
  })
  const [tenantData, setTenantData] = useState({
    bannerTitle1: "",
    bannerContent1: "",
    bannerImg1: "",
    bannerTitle2: "",
    bannerContent2: "",
    bannerImg2: "",
    bannerTitle3: "",
    bannerContent3: "",
    bannerImg3: "",
    fbLink: "",
    instaLink: "",
    logo: "",
    name: "",
    id: ""
  });

  useEffect(() => {
    const name = isTenantGroup ? tenantGroupData.name : tenantData.name;
    if (name) document.title = name;
  }, [isTenantGroup, tenantData.name, tenantGroupData.name]);

  const loadingPlaceholder = (
    <div style={{ minHeight: '78vh', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
      <img src={icLogo} alt="" width="200" style={{ width: 200, marginBottom: 16 }} />
      <div style={{ fontWeight: 600, fontFamily: "'Cormorant Garamond', serif", fontStyle: 'italic', color: 'var(--f-forest-deep, #1b2c42)' }}>Loading</div>
    </div>
  );

  return (
    <div className="variant-f">
      <Router>
        <ScrollFixToTop>
          <Suspense fallback={<Loader />}>
            <Switch>
              <Route exact path="/" render={(props) => {
                  if (isLoading) {
                    return <Layout hasDarkTopBar={false} tenantData={tenantData}>{loadingPlaceholder}</Layout>;
                  }
                  return isTenantGroup
                    ? <TenantGroupIndex {...props} tenantGroupData={tenantGroupData} />
                    : <Layout hasDarkTopBar={false} tenantData={tenantData}><TenantIndex {...props} tenantData={tenantData} /></Layout>;
                }} />
                <Route path="/room-type" render={(props) => <Layout hasDarkTopBar={false} tenantData={tenantData}><RoomDetail {...props} tenantData={tenantData} /></Layout>} />
                <Route path="/payment" render={(props) => <Layout hasDarkTopBar={false} tenantData={tenantData}><Payment {...props} /></Layout>} />
                <Route path="/booking-confirmation" render={(props) => <Layout hasDarkTopBar={false} tenantData={tenantData}><BookingConfirm {...props} tenantData={tenantData} /></Layout>} />
              <Route path="/theme-preview" render={() => <Layout hasDarkTopBar={false} tenantData={tenantData}><ThemePreview /></Layout>} />
            </Switch>
          </Suspense>
        </ScrollFixToTop>
      </Router>
    </div>
  );
}

export default withLocalize(withRouter(App));